import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  imports: [],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
})
export class CheckboxComponent {
  /** Identificador único do input; usado para associar o <label> (acessibilidade). */
  @Input() id = '';
  /** Nome do campo. */
  @Input() name = '';
  /** Texto exibido ao lado da caixa. */
  @Input() label = '';
  /** Indica se está marcado. */
  @Input() checked = false;
  /** Desabilita o checkbox. */
  @Input() disabled = false;
  /** Cor do label quando desmarcado; se omitida, usa a cor padrão. */
  @Input() uncheckedLabelColor?: string;
  /** Cor do label quando marcado; se omitida, usa a cor padrão. */
  @Input() checkedLabelColor?: string;

  /** Emite o novo valor; habilita two-way binding via [(checked)]. */
  @Output() checkedChange = new EventEmitter<boolean>();
  /** Emite o evento nativo quando o estado muda. */
  @Output() change = new EventEmitter<Event>();

  /** Cor padrão do label, usada quando nenhuma cor é informada para o estado atual. */
  private static readonly DEFAULT_LABEL_COLOR = 'black';

  /** Cor do label conforme o estado atual; reavaliada quando `checked` muda. */
  get labelColor(): string {
    const color = this.checked ? this.checkedLabelColor : this.uncheckedLabelColor;
    return color || CheckboxComponent.DEFAULT_LABEL_COLOR;
  }

  onChange(event: Event): void {
    this.checked = (event.target as HTMLInputElement).checked;
    this.checkedChange.emit(this.checked);
    this.change.emit(event);
  }
}
